(function () {
  'use strict';

  var state = { step: 1, lookups: null, selectedPersonas: [], sourceContext: readSourceContext() };
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var fullMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var artImages = {
    1: '/img/revealimage2.jpg',
    2: 'https://content.thrillexperiences.com.au/content/static/reminder4.jpg',
    3: 'https://content.thrillexperiences.com.au/content/static/reminder5.jpg',
    4: 'https://content.thrillexperiences.com.au/content/static/reminder5.jpg'
  };

  function $(selector) { return document.querySelector(selector); }
  function $all(selector) { return Array.prototype.slice.call(document.querySelectorAll(selector)); }

  function api(path, options) {
    options = options || {};
    options.credentials = 'same-origin';
    options.headers = Object.assign({
      'Accept': 'application/json',
      'X-CSRF-Token': window.csrfToken || ''
    }, options.headers || {});
    if (options.body && !options.headers['Content-Type']) options.headers['Content-Type'] = 'application/json';
    return fetch('/inc/api/gift-reminders/' + path + '.aspx', options).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || json.success === false) throw new Error(json.message || 'We could not save your reminder.');
        return json;
      });
    });
  }

  function openModal() {
    $('#publicReminderModal').classList.add('is-open');
    $('#publicReminderModal').setAttribute('aria-hidden', 'false');
    document.body.classList.add('public-reminder-modal-open');
    $('#publicReminderRecipient').focus();
  }

  function closeModal() {
    $('#publicReminderModal').classList.remove('is-open');
    $('#publicReminderModal').setAttribute('aria-hidden', 'true');
    document.body.classList.remove('public-reminder-modal-open');
  }

  function setStep(step) {
    state.step = step;
    $all('.public-reminder-step').forEach(function (panel) {
      panel.classList.toggle('is-active', parseInt(panel.getAttribute('data-step'), 10) === step);
    });
    $all('.public-reminder-progress span').forEach(function (bar, index) {
      bar.classList.toggle('is-active', index < Math.min(step, 3));
    });
    var title = step === 2 ? 'Make it feel like Them' : step === 3 ? "Lock It In.  Done." : 'Build your gifting calendar';
    $('#publicReminderArtTitle').textContent = title;
    setArtImage(step);
  }

  function setArtImage(step) {
    var art = $('.public-reminder-art');
    var imageUrl = artImages[step] || artImages[1];
    if (!art) return;
    art.style.backgroundImage = 'linear-gradient(rgba(0,0,0,.18), rgba(0,0,0,.18)), url("' + imageUrl + '")';
  }

  function fillLookups() {
    return api('lookups').then(function (json) {
      state.lookups = json.lookups || json.Lookups || {};
      fillSelect($('#publicReminderOccasion'), state.lookups.OccasionTypes || state.lookups.occasionTypes || [], 'Occasion');
      fillDays();
      fillMonths();
      renderPersonas(state.lookups.Personas || state.lookups.personas || []);
      updatePreview();
    });
  }

  function fillSelect(select, values, placeholder) {
    select.innerHTML = '<option value="">' + placeholder + '</option>';
    values.forEach(function (item) {
      var option = document.createElement('option');
      option.value = item.Id || item.id;
      option.textContent = item.Name || item.name;
      select.appendChild(option);
    });
  }

  function fillDays() {
    var select = $('#publicReminderDay');
    select.innerHTML = '<option value="">DD</option>';
    for (var day = 1; day <= 31; day += 1) {
      var option = document.createElement('option');
      option.value = day;
      option.textContent = day < 10 ? '0' + day : String(day);
      select.appendChild(option);
    }
  }

  function fillMonths() {
    var select = $('#publicReminderMonth');
    select.innerHTML = '<option value="">MM</option>';
    months.forEach(function (month, index) {
      var option = document.createElement('option');
      option.value = index + 1;
      option.textContent = month;
      select.appendChild(option);
    });
  }

  function renderPersonas(personas) {
    var wrap = $('#publicReminderTags');
    wrap.innerHTML = personas.map(function (persona) {
      return '<button type="button" class="public-reminder-tag" data-id="' + (persona.Id || persona.id) + '">' + escapeHtml(persona.Name || persona.name) + '</button>';
    }).join('');
  }

  function validateStep1() {
    return $('#publicReminderRecipient').value.trim() && $('#publicReminderOccasion').value && $('#publicReminderDay').value && $('#publicReminderMonth').value;
  }

  function getSelectedOccasionText() {
    var select = $('#publicReminderOccasion');
    if (!select || !select.value || select.selectedIndex < 0) return '';
    return select.options[select.selectedIndex].textContent || '';
  }

  function isValidDayMonth(day, month) {
    var date = new Date(2024, month - 1, day);
    return date.getMonth() === month - 1 && date.getDate() === day;
  }

  function buildPreviewDateText(day, month) {
    var today = new Date();
    var startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    var occurrence = new Date(today.getFullYear(), month - 1, day);

    if (occurrence < startOfToday) {
      occurrence = new Date(today.getFullYear() + 1, month - 1, day);
    }

    var daysToGo = Math.round((occurrence - startOfToday) / 86400000);
    var dayLabel = pad(day);
    var monthLabel = fullMonths[month - 1] || '';
    return dayLabel + ' ' + monthLabel + ' (' + daysToGo + (daysToGo === 1 ? ' day' : ' days') + ' to go)';
  }

  function updatePreview() {
    var recipientInput = $('#publicReminderRecipient');
    var daySelect = $('#publicReminderDay');
    var monthSelect = $('#publicReminderMonth');
    var recipient = recipientInput ? recipientInput.value.trim() : '';
    var occasion = getSelectedOccasionText();
    var day = parseInt(daySelect && daySelect.value, 10);
    var month = parseInt(monthSelect && monthSelect.value, 10);
    var hasValidDate = !isNaN(day) && !isNaN(month) && isValidDayMonth(day, month);

    $('#publicReminderPreviewMonth').textContent = hasValidDate ? months[month - 1].toUpperCase() : 'JUN';
    $('#publicReminderPreviewDay').textContent = hasValidDate ? pad(day) : '16';
    $('#publicReminderPreviewName').textContent = recipient ? recipient + "'s" : 'Name';
    $('#publicReminderPreviewOccasion').textContent = occasion || 'Occasion';
    $('#publicReminderPreviewDate').textContent = hasValidDate ? buildPreviewDateText(day, month) : '16 June';
  }

  function buildEventDate() {
    var now = new Date();
    var year = now.getFullYear();
    var month = parseInt($('#publicReminderMonth').value, 10);
    var day = parseInt($('#publicReminderDay').value, 10);
    var candidate = new Date(year, month - 1, day);
    if (candidate.getMonth() !== month - 1) throw new Error('Choose a valid day and month.');
    return year + '-' + pad(month) + '-' + pad(day);
  }

  function buildPayload() {
    var occasionText = $('#publicReminderOccasion').options[$('#publicReminderOccasion').selectedIndex].text;
    var recipient = $('#publicReminderRecipient').value.trim();
    return {
      reminderName: recipient + "'s " + occasionText.toLowerCase(),
      recipientName: recipient,
      occasionTypeId: parseInt($('#publicReminderOccasion').value, 10),
      eventDate: buildEventDate(),
      isRecurringAnnual: true,
      personaIds: state.selectedPersonas.slice(),
      emailReminderDaysBefore: [14],
      emailRemindersEnabled: true,
      reminderOnlyEmailConsent: true,
      giftIdeasAndOffersEmailConsent: false,
      email: $('#publicReminderEmail').value.trim(),
      sourceType: state.sourceContext.sourceType || 'PublicGiftReminders',
      sourceProductId: state.sourceContext.productId,
      sourceCategoryId: state.sourceContext.categoryId,
      sourceSubCategoryId: state.sourceContext.subCategoryId,
      sourceProductUrl: state.sourceContext.productUrl
    };
  }

  function readSourceContext() {
    var params = new URLSearchParams(window.location.search || '');
    return {
      sourceType: params.get('source'),
      productId: toNullableInt(params.get('productId')),
      categoryId: toNullableInt(params.get('categoryId')),
      subCategoryId: toNullableInt(params.get('subCategoryId')),
      productUrl: params.get('productUrl') || ''
    };
  }

  function toNullableInt(value) {
    var parsed = parseInt(value || '', 10);
    return isNaN(parsed) ? null : parsed;
  }

  function submitForm(event) {
    event.preventDefault();
    hideAlert();
    var payload;
    try {
      payload = buildPayload();
    } catch (err) {
      showAlert(err.message);
      return;
    }
    api('create', { method: 'POST', body: JSON.stringify(payload) }).then(function () {
      setStep(4);
    }).catch(function (err) {
      showAlert(err.message);
    });
  }

  function showAlert(message) {
    var alert = $('#publicReminderAlert');
    alert.textContent = message;
    alert.style.display = '';
  }

  function hideAlert() {
    var alert = $('#publicReminderAlert');
    alert.textContent = '';
    alert.style.display = 'none';
  }

  function resetForm() {
    $('#publicReminderForm').reset();
    state.selectedPersonas = [];
    $all('.public-reminder-tag').forEach(function (tag) { tag.classList.remove('is-selected'); });
    setStep(1);
    updatePreview();
  }

  function pad(value) { return value < 10 ? '0' + value : String(value); }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '\'': '&#39;', '"': '&quot;' })[char];
    });
  }

  function initHeroCarousel() {
    var carousel = $('[data-public-reminders-carousel]');
    if (!carousel) return;

    var slides = Array.prototype.slice.call(carousel.querySelectorAll('.public-reminders-slide'));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('.public-reminders-dot'));
    var mobileQuery = window.matchMedia('(max-width: 900px)');
    var currentIndex = 0;
    var intervalId;

    function getActiveItems() {
      return {
        slides: slides.filter(function (slide) {
          return mobileQuery.matches || !slide.classList.contains('public-reminders-mobile-only');
        }),
        dots: dots.filter(function (dot) {
          return mobileQuery.matches || !dot.classList.contains('public-reminders-mobile-only');
        })
      };
    }

    function showSlide(index) {
      var activeItems = getActiveItems();
      if (!activeItems.slides.length) return;
      currentIndex = (index + activeItems.slides.length) % activeItems.slides.length;
      slides.forEach(function (slide) {
        slide.classList.remove('is-active');
      });
      dots.forEach(function (dot) {
        dot.classList.remove('is-active');
      });
      activeItems.slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === currentIndex);
      });
      activeItems.dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === currentIndex);
      });
    }

    function start() {
      var activeItems = getActiveItems();
      window.clearInterval(intervalId);
      if (activeItems.slides.length < 2) return;
      intervalId = window.setInterval(function () {
        showSlide(currentIndex + 1);
      }, 3000);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var activeDots = getActiveItems().dots;
        var dotIndex = activeDots.indexOf(dot);
        if (dotIndex < 0) return;
        window.clearInterval(intervalId);
        showSlide(dotIndex);
        start();
      });
    });

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', function () {
        showSlide(0);
        start();
      });
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(function () {
        showSlide(0);
        start();
      });
    }

    showSlide(0);
    start();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeroCarousel();
    if (!$('#publicReminderModal')) return;
    fillLookups().catch(function () {});
    var openButtons = $all('[data-public-reminder-open]');
    if (!openButtons.length && $('#publicReminderOpen')) openButtons = [$('#publicReminderOpen')];
    openButtons.forEach(function (button) {
      button.addEventListener('click', openModal);
    });
    $('#publicReminderClose').addEventListener('click', closeModal);
    $('#publicReminderAgain').addEventListener('click', resetForm);
    $('#publicReminderForm').addEventListener('submit', submitForm);
    $('#publicReminderRecipient').addEventListener('input', updatePreview);
    $('#publicReminderOccasion').addEventListener('change', updatePreview);
    $('#publicReminderDay').addEventListener('change', updatePreview);
    $('#publicReminderMonth').addEventListener('change', updatePreview);
    $all('[data-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (state.step === 1 && !validateStep1()) return;
        setStep(Math.min(state.step + 1, 3));
      });
    });
    $('#publicReminderTags').addEventListener('click', function (event) {
      var button = event.target.closest('.public-reminder-tag');
      if (!button) return;
      var id = parseInt(button.getAttribute('data-id'), 10);
      var index = state.selectedPersonas.indexOf(id);
      if (index >= 0) {
        state.selectedPersonas.splice(index, 1);
        button.classList.remove('is-selected');
      } else if (state.selectedPersonas.length < 3) {
        state.selectedPersonas.push(id);
        button.classList.add('is-selected');
      }
    });
  });
}());
